import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Table, Tag } from "antd";
import { del, get } from "../../api/axios";
import { Pagination, message } from "antd";
import { Link } from "react-router-dom";
import SearchBar from "../../utils/SearchBar";

const Sales = () => {
  // render: (role) => (role == null ? "" : role.name),
  const columns = [
    //1
    //بيانات الحجز
    {
      title: (
        <>
          بيانات الحجز
          <br />
          رقم الحجز
          <br />
          حالة الحجز
          <br />
          مصدر الحجز
          <br />
          جهة الحجز
          <br />
          تاريخ انشاء الحجز
          <br />
          كود الوحدة
          <br />
          سياسة الالغاء
        </>
      ),
      width: "250px",

      render: ({
        id,
        status,
        date_of_creation,
        time_of_creation,
        reservation_source,
        cancellation_policy,
        reservation_os,
        property,
      }) => (
        <span>
          <strong>{id}</strong>
          <br />
          <Tag color={status === "confirmed" ? "green" : "orange"}>
            {status}
          </Tag>
          <br />
          {reservation_source === "user" ? "مكان" : "مضيف"}
          <br />
          {reservation_source || "-"}
          <br />
          {date_of_creation}
          <br />
          {property?.id ? `U${property?.id}` : "-"}
          <br />
          {cancellation_policy || "-"}
        </span>
      ),
    },

    //2
    //بيانات الاقامة
    {
      title: (
        <>
          بيانات الإقامة
          <br />
          اسم الوحدة
          <br />
          المدينة
          <br />
          الحي
          <br />
          تاريخ الوصول
          <br />
          تاريخ المغادرة
          <br />
          وقت الوصول
          <br />
          وقت المغادرة
          <br />
          مدة الإقامة
        </>
      ),
      width: "200px",

      render: (_, record) => {
        const { arriving_time, leaving_time, date } =
          record.arrives_leaves || {};

        const { daysNumbers, property } = record;

        const splitDateRange = (date) => {
          if (!date || typeof date !== "string") {
            return { from: "-", to: null };
          }

          const parts = date.split(" - ");

          return {
            from: parts[0],
            to: parts[1] || null,
          };
        };

        const { from, to } = splitDateRange(date);

        return (
          <div>
            {property?.name || "-"}
            <br />
            {property?.city || "-"}
            <br />
            {property?.district || "-"}
            <br />
            {from}
            <br />
            {to || "-"}
            <br />
            {arriving_time || "-"}
            <br />
            {leaving_time || "-"}
            <br />
            {daysNumbers || "-"}
          </div>
        );
      },
    },

    //3
    //بيانات الضيف والمضيف
    {
      title: (
        <>
          بيانات الضيف والمضيف
          <br />
          اسم الضيف
          <br />
          البريد الإلكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
          اسم المضيف
          <br />
          البريد الإلكتروني
          <br />
          الجوال
          <br />
          رقم المضيف
          <br />
        </>
      ),
      render: ({ user, owner }) => (
        <>
          {user?.name || "-"} <br />
          {user?.email || "-"} <br />
          {user?.phone || "-"} <br />
          {user?.id ? `G${user?.id}` : "-"} <br />
          {owner?.name || "-"} <br />
          {owner?.email || "-"} <br />
          {owner?.phone || "-"} <br />
          {owner?.id ? `H${owner?.id}` : "-"} <br />
        </>
      ),
    },

    //4
    //بيانات السعر
    {
      title: (
        <>
          بيانات السعر
          <br />
          طريقة السداد
          <br />
          المدة * سعر الليلة
          <br />
          إجمالي السعر
          <br />
          العرض
          <br />
          كود خصم
          <br />
          مبلغ الحجز
          <br />
          رسوم الخدمة
          <br />
          المجموع
        </>
      ),
      width: "200px",

      render: ({ prices, daysNumbers, total_price, payment_method }) => (
        <>
          {payment_method || "-"} <br />
          {daysNumbers} * {prices.avg_price} <br />
          {prices.totalPrice} <br />
          {prices.offers_amount} <br />
          {prices.coupon_amount} <br />
          {prices.subTotal} <br />
          {prices.total_service} <br />
          {total_price} <br />
        </>
      ),
    },

    //7
    // // بيانات الإيداع
    {
      title: (
        <>
          بيانات الإيداع
          <br />
          المدفوع من الضيف
          <br />
          (رسوم الإيداع)
          <br />
          (ضريبة رسوم الإيداع)
          <br />
          مبلغ الإيداع
        </>
      ),
      render: ({ total_price, deposit }) => {
        return (
          <>
            {total_price || "-"} {/* ✅ هون الصح */}
            <br />
            {deposit?.deposit_fee || "-"}
            <br />
            {deposit?.deposit_fee_tax || "-"}
            <br />
            {deposit?.deposit_amount || "-"}
          </>
        );
      },
    },

    //8
    // الرسوم
    {
      title: (
        <>
          الرسوم
          <br />
          المدفوع من الضيف
          <br />
          مبيعات مكان من الرسوم
          <br />
          مبيعات مكان (ضريبة الرسوم)
          <br />
          مبيعات مكان (الرسوم شامل الضريبة)
          <br />
          مبيعات المضيف
        </>
      ),
      dataIndex: "prices",
      render: ({
        totalPrice,
        service_amount,
        service_tax,
        total_service,
        total_price_without_service,
      }) => (
        <span>
          {totalPrice}
          <br />
          {service_amount}
          <br />
          {service_tax}
          <br />
          {total_service}
          <br />
          {total_price_without_service}
        </span>
      ),
    },

    //9
    // العمولة
    {
      title: (
        <>
          العمولة
          <br />
          مبيعات المضيف
          <br />
          مبيعات مكان من العمولة
          <br />
          مبيعات مكان (ضريبة العمولة)
          <br />
          مبيعات مكان (العمولة شامل الضريبة)
          <br />
          صافي مبيعات المضيف
        </>
      ),
      dataIndex: "prices",
      render: ({
        total_price_without_service,
        commission_amount,
        commission_tax_amount,
        total_commission,
        total_price_without_service_commission,
      }) => (
        <span>
          {total_price_without_service}
          <br />
          {commission_amount}
          <br />
          {commission_tax_amount}
          <br />
          {total_commission}
          <br />
          {total_price_without_service_commission}
        </span>
      ),
    },

    //10
    // الرسوم والعمولة
    {
      title: (
        <>
          الرسوم والعمولة
          <br />
          الرسوم و العمولة
          <br />
          (ضرائب الرسوم و العمولة)
          <br />
          (الرسوم و العمولة شامل الضرائب)
        </>
      ),
      dataIndex: "prices",
      render: ({
        commission_service_amount,
        commission_service_tax,
        commission_service_total,
      }) => (
        <span>
          {commission_service_amount}
          <br />
          {commission_service_tax}
          <br />
          {commission_service_total}
        </span>
      ),
    },

    //11
    // بيانات الحوالة أو الأسترداد
    {
      title: (
        <>
          بيانات الحوالة
          <br />
          مبلغ التحويل
          <br />
          (رسوم التحويل)
          <br />
          (ضريبة رسوم التحويل)
          <br />
          (رسوم التحويل شامل الضريبة)
          <br />
          مبلغ التحويل و (رسوم التحويل شامل الضريبة)
        </>
      ),

      render: ({ invoice_transfers }) => {
        const t = invoice_transfers?.[0];

        if (!t) {
          return (
            <>
              -<br />-<br />-<br />-<br />-
            </>
          );
        }

        const amount = parseFloat(t.transfer_amount) || 0;
        const totalFees = parseFloat(t.total_transfer_fees) || 0;

        return (
          <>
            {t.transfer_amount}
            <br />
            {t.transfer_fees}
            <br />
            {t.transfer_tax}
            <br />
            {t.total_transfer_fees}
            <br />
            {amount + totalFees}
          </>
        );
      },
    },
    //11
    // بيانات صافي المبيعات
    {
      title: (
        <>
          بيانات صافي المبيعات
          <br />
          مبلغ الإيداع
          <br />
          مبلغ التحويل و (رسوم التحويل شامل الضريبة)
          <br />
          مبيعات مكان (ضريبة الرسوم)
          <br />
          مبيعات مكان (ضريبة العمولة)
          <br />
          صافي مبيعات مكان
        </>
      ),

      render: ({ invoice_transfers, prices, total_price, deposit }) => {
        const t = invoice_transfers?.[0];

        // ✅ مبلغ الإيداع = total_price
        const depositAmount = parseFloat(deposit?.deposit_amount) || 0;

        // ✅ مبلغ التحويل + الرسوم + الضريبة
        const transferAmount = parseFloat(t?.transfer_amount) || 0;
        const transferFees = parseFloat(t?.transfer_fees) || 0;
        const transferTax = parseFloat(t?.transfer_tax) || 0;

        const transferTotal = transferAmount + transferFees + transferTax;

        // ✅ الضرائب
        const serviceTax = parseFloat(prices?.service_tax) || 0;
        const commissionTax = parseFloat(prices?.commission_tax_amount) || 0;

        // ✅ صافي مبيعات مكان
        const net = depositAmount - transferTotal - serviceTax - commissionTax;

        return (
          <>
            {depositAmount || "-"}
            <br />
            {transferTotal || "-"}
            <br />
            {serviceTax || "-"}
            <br />
            {commissionTax || "-"}
            <br />
            {net || "-"} {/* ✅ النتيجة النهائية */}
          </>
        );
      },
    },

    // {
    //   title: (
    //     <>
    //       بيانات الحجز
    //       <br />
    //       تاريخ انشاء الحجز
    //       <br />
    //       وقت الحجز <br />
    //       مصدر الحجز
    //     </>
    //   ),
    //   render: ({ date_of_creation, time_of_creation, reservation_source }) => (
    //     <span>
    //       <br />
    //       {date_of_creation}
    //       <br />
    //       {time_of_creation}
    //       <br />
    //       {reservation_source === "user" ? "مكان" : "مضيف"} <br />
    //     </span>
    //   ),
    // },
    // {
    //   title: (
    //     <>
    //       بيانات الإقامة
    //       <br />
    //       تاريخ الوصول
    //       <br />
    //       تاريخ المغادرة
    //       <br />
    //       وقت الوصول
    //       <br />
    //       وقت المغادرة
    //       <br />
    //       مدة الإقامة
    //     </>
    //   ),
    //   dataIndex: "arrives_leaves",
    //   render: (
    //     { date, arriving_time, leaving_time, type },
    //     { daysNumbers },
    //   ) => {
    //     const splitDateRange = (date) => {
    //       if (!date || typeof date !== "string") {
    //         return { from: "-", to: null };
    //       }

    //       const parts = date.split(" - ");

    //       return {
    //         from: parts[0],
    //         to: parts[1] || null,
    //       };
    //     };

    //     const { from, to } = splitDateRange(date);

    //     return (
    //       <div>
    //         {from}
    //         {to && <div>{to}</div>}
    //         {arriving_time || "-"}
    //         <br />
    //         {leaving_time || "-"}
    //         <br />
    //         {daysNumbers || "-"}
    //       </div>
    //     );
    //   },
    // },

    // {
    //   title: (
    //     <>
    //       بيانات الوحدة
    //       <br />
    //       الوحدة
    //       <br />
    //       المدينة
    //       <br />
    //       الحي
    //       <br />
    //       كود الوحدة
    //       <br />
    //       سياسة الالغاء
    //     </>
    //   ),
    //   dataIndex: "",
    //   render: ({ property, cancellation_policy }) => (
    //     <span>
    //       {property?.name || "-"}
    //       <br />
    //       {property?.city || "-"}
    //       <br />
    //       {property?.district || "-"}
    //       <br />
    //       {property?.code || "-"}
    //       <br />
    //       {cancellation_policy || "-"}
    //     </span>
    //   ),
    // },
    // {
    //   title: (
    //     <>
    //       طريقة السداد
    //       <br />
    //       المدة * السعر
    //       <br />
    //       إجمالي السعر
    //       <br />
    //       العرض
    //       <br />
    //       كود خصم
    //       <br />
    //       مبلغ الحجز
    //       <br />
    //       رسوم الخدمة
    //       <br />
    //       المجموع
    //     </>
    //   ),

    //   render: ({ prices, daysNumbers, total_price, payment_method }) => (
    //     <>
    //       {payment_method || "-"} <br />
    //       {daysNumbers} * {prices.avg_price} <br />
    //       {prices.totalPrice} <br />
    //       {prices.offers_amount} <br />
    //       {prices.coupon_amount} <br />
    //       {prices.subTotal} <br />
    //       {prices.total_service} <br />
    //       {total_price} <br />
    //     </>
    //   ),
    // },

    // {
    //   title: (
    //     <>
    //       المدفوع من الضيف
    //       <br />
    //       صافي مبيعات مكان (الرسوم)
    //       <br />
    //       ضريبة القيمة المضافة(الرسوم)
    //       <br />
    //       (الرسوم شامل الضريبة)
    //       <br />
    //       مبيعات المضيف
    //     </>
    //   ),
    //   dataIndex: "prices",
    //   render: ({
    //     totalPrice,
    //     service_amount,
    //     service_tax,
    //     total_service,
    //     total_price_without_service,
    //   }) => (
    //     <span>
    //       {totalPrice}
    //       <br />
    //       {service_amount}
    //       <br />
    //       {service_tax}
    //       <br />
    //       {total_service}
    //       <br />
    //       {total_price_without_service}
    //     </span>
    //   ),
    // },
    // {
    //   title: (
    //     <>
    //       مبيعات المضيف
    //       <br />
    //       صافي مبيعات مكان (العمولة)
    //       <br />
    //       ضريبة القيمة المضافة (العمولة)
    //       <br />
    //       (العمولة شامل الضريبة)
    //       <br />
    //       صافي مبيعات المضيف
    //     </>
    //   ),
    //   dataIndex: "prices",
    //   render: ({
    //     total_price_without_service,
    //     commission_amount,
    //     commission_tax_amount,
    //     total_commission,
    //     total_price_without_service_commission,
    //   }) => (
    //     <span>
    //       {total_price_without_service}
    //       <br />
    //       {commission_amount}
    //       <br />
    //       {commission_tax_amount}
    //       <br />
    //       {total_commission}
    //       <br />
    //       {total_price_without_service_commission}
    //     </span>
    //   ),
    // },
  ];

  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get(`invoices?search=${searchQuery}`).then((res) => {
      setdata(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);
  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`invoices?page=${pageNumber}`).then((res) => {
      setdata(res?.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              // loading={loading}
              pagination={false}
              bordered
              scroll={{
                y: "65vh",
                x: 1650,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sales;
